import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Organisation } from '../../models/organisation';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomerService } from '../services/customer.service';
import { InvoicesService } from '../services/invoices.service';
import { Customer } from '../../models/customer';
import { Invoice } from '../../models/invoice';
import { InvoiceLine } from '../../models/invoice-line';
import { MessageService } from 'primeng/components/common/messageservice';
import { CalendarModule } from 'primeng/components/calendar/calendar';

@Component({
	selector: 'app-invoice-create',
	templateUrl: 'invoice-create.template.html'
})

/**
 * Component for the invoice settings page
 */
export class InvoiceCreateComponent implements OnInit
{
	invoice: Invoice;

	invoiceLine: InvoiceLine;

	organisation: Organisation;

	customers: Customer;

	errors = {};

	//
	// /**
	//  * InvoiceCreateComponent constructor
	//  *
	//  * @param {ActivatedRoute} route
	//  * @param {Router} router
	//  */
	constructor(private route: ActivatedRoute,
		private router: Router,
		private invoicesService: InvoicesService,
		private calendarModule: CalendarModule,
		private messageService: MessageService)
	{
		this.invoice = new Invoice();

		this.invoice.invoiceLines = new Array<InvoiceLine>();
	}

	public createInvoiceLine()
	{
		this.invoiceLine = new InvoiceLine();
	}

	public saveInvoice()
	{
		if(
			this.invoice.customer_id === undefined
		)
		{
			this.messageService.add({
				summary: 'Fout',
				detail: ' Je hebt geen klant of een debiteur contactpersoon opgegeven.',
				severity: 'error'
			});

			return;
		}
		else if( this.invoice.invoiceLines.length <= 0 )
		{
			this.messageService.add({
				summary: 'Fout',
				detail: ' Je kan geen lege factuur aanmaken..',
				severity: 'error'
			});

			return;
		}

		this.invoicesService.storeInvoice(this.invoice).subscribe(
			data => {
				this.messageService.add({
					summary: 'Succes',
					detail: 'Er is een nieuwe factuur aangemaakt.',
					severity: 'success'
				});
				this.router.navigate(['/facturen']);
			},
			err => {
				if (err instanceof HttpErrorResponse) {
					this.errors = err.error.message;
				}
			}
		);
	}

	public saveInvoiceLine()
	{
		if(
			this.invoiceLine.characteristic === undefined ||
			this.invoiceLine.characteristic == "" ||
			this.invoiceLine.description === undefined ||
			this.invoiceLine.description == "" ||
			this.invoiceLine.amount === undefined ||
			this.invoiceLine.amount == 0 ||
			this.invoiceLine.price_per_unit === undefined ||
			this.invoiceLine.price_per_unit == 0 ||
			this.invoiceLine.price_unit === undefined ||
			this.invoiceLine.price_unit == "" ||
			this.invoiceLine.vat_type === undefined ||
			this.invoiceLine.vat_type == ""
		)
		{
			this.messageService.add({
				summary: 'Fout',
				detail: 'Niet alle factuurregels zijn correct ingevuld.',
				severity: 'error'
			});

			return;
		}

		if( this.invoiceLine.price_unit == "price_per_unit" )
		{
			this.invoiceLine.price_ex_vat = this.invoiceLine.amount * this.invoiceLine.price_per_unit;
		}
		else if( this.invoiceLine.price_unit == "price_per_thousand" )
		{
			this.invoiceLine.price_ex_vat = this.invoiceLine.amount / 1000 * this.invoiceLine.price_per_unit;
		}

		//FIXME: er wordt niet gekeken of btw tarieven veranderen
		if( this.invoiceLine.vat_type == "high" )
		{
			this.invoiceLine.price_inc_vat = this.invoiceLine.price_ex_vat * 1.21;
		}
		else if( this.invoiceLine.vat_type == "low" )
		{
			this.invoiceLine.price_inc_vat = this.invoiceLine.price_ex_vat * 1.09;
		}
		else
		{
			this.invoiceLine.price_inc_vat = this.invoiceLine.price_ex_vat;
		}


		this.invoice.invoiceLines.push( this.invoiceLine );
		this.invoiceLine = new InvoiceLine();
	}

	public deleteInvoiceLine(invoiceLine: InvoiceLine)
	{
		this.invoice.invoiceLines.forEach( (invoiceLineArray, index) => {
			if( invoiceLineArray == invoiceLine )
			{
				this.invoice.invoiceLines.splice(index, 1);
			}
		});
	}

	public editInvoiceLine(invoiceLine: InvoiceLine)
	{
		this.invoice.invoiceLines.forEach( (invoiceLineArray, index) => {
			if( invoiceLineArray == invoiceLine )
			{
				this.invoiceLine = invoiceLine;
				this.invoice.invoiceLines.splice(index, 1);
			}
		});
	}

	//
	// /**
	//  * Lifecycle hook that is called after data-bound properties of this component are
	//  * initialized.
	//  */
	ngOnInit()
	{
		this.route.data.subscribe(
			(data: { organisation: Organisation, customers: Customer }) => {
				console.log(data);
				this.organisation = data.organisation;
				this.customers = data.customers;
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-create/invoice-create.component.ts